import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, ValidationService, DateService, DataService } from 'app/services';
import { ImageCropperDialogComponent } from 'app/modules/app-components/image-cropper-dialog/image-cropper-dialog.component';

import { AutoLeap } from 'app/constants/autoleap.constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { CommissionEarnedDialogComponent } from 'app/modules/app-components/commission-earned-dialog/commission-earned-dialog.component';

import { CookieService } from 'ngx-cookie';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-personal-info-card',
  templateUrl: './personal-info-card.component.html',
  styleUrls: ['./personal-info-card.component.scss'],
  providers: [DialogService],
})
export class PersonalInfoCardComponent implements OnInit {
  @Input('data')
  set data(data) {
    if (data) {
      this.user = { ...data };
      this._user = { ...data };

      this.userHasAudibleNotification = this._user.hasAudibleNotifications;
      this.previewImage = data.image;
      this.initials = data.initials;
    }
  }

  @Output() getUser = new EventEmitter<any>();
  @Output() toggleCard = new EventEmitter<any>();

  @ViewChild('closeDropdownElement')
  closeDropdownElement: ElementRef;
  greeting: string = '';
  serverTime: any = '';
  isProcessing: boolean = false;
  techId: string = '';
  tech: any = {};
  loggedHours: any = '';
  clockInTime: string = '';
  startOfSession: any = '';
  dataServiceListener: any = '';
  activeView: any = 'week'; // day, week, month
  startDate: any;
  endDate: any;
  employee;
  loading = true;
  clocks = [];
  daysOfWeek = [];
  isTechManualTechLogEnabled: boolean = false;
  isSuccess: boolean = false;
  userHasAudibleNotification: boolean = false;
  showAudibleNotification: boolean = false;
  isEditable: boolean = false;
  user: any = {};
  _user: any = {};
  errors: any = {};
  focus: any = {};
  initials: string = '';
  previewImage: string = '';
  isUploading: boolean = false;
  isWorkAsTechEnabled: boolean = false;
  isCommissionVisibleForTechsServiceWriters: boolean = false;
  dataServiceSubscription: Subscription;

  constructor(
    private titleService: Title,
    private httpService: HTTPService,
    private helperService: HelperService,
    private router: Router,
    private cookieService: CookieService,
    private validationService: ValidationService,
    private dialogService: DialogService,
    private dateService: DateService,
    private dataService: DataService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const { role } = this.helperService.getCompany();

    if (['serviceWriter', 'admin'].includes(role)) {
      this.getEmployeeData();
    }
    this.setDataListners();
  }

  setDataListners() {
    this.dataServiceSubscription = this.dataService.getData().subscribe((obj) => {
      if (obj.data.key === 'company-appdata-updated') {
        this.setFlaggedData();
        this.dataServiceSubscription.unsubscribe();
      }
    });
    this.setFlaggedData();
  }

  setFlaggedData() {
    this.isCommissionVisibleForTechsServiceWriters = this.dataService.isCommissionVisibleForTechsServiceWriters && this.helperService.shouldDisplayCommissionPlan();
  }

  getEmployeeData() {
    this.isProcessing = true;
    this.httpService.techTimeClockDetails().then(
      ({ clockIn, employee, serverTime, timeLogged }: any) => {
        // this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then(company =>{
        this.showAudibleNotification = this.dataService.isAudibleNotificationsEnabled;
        this.tech = employee;
        this.isProcessing = false;
        this.isWorkAsTechEnabled = this.tech.isWorkAsTechEnabled;
        this.serverTime = this.dateService.getCurrentDateTimeTz(serverTime);
        this.loggedHours = timeLogged;
        // this.getTechClockDetail();
        if (employee.clockedIn && clockIn) {
          this.startOfSession = this.dateService.getCurrentDateTimeTz(new Date(clockIn.createdAt).getTime());
          this.clockInTime = this.dateService.formatDate(this.startOfSession, datetimeFormat.hmma);
          timeLogged = timeLogged / 60000;
          const hours = Math.floor(timeLogged / 60);
          const mins = Math.floor(timeLogged) % 60;
          this.loggedHours = `${hours} hour${hours > 1 ? 's' : ''} ${mins} minute${mins > 1 ? 's' : ''}`;
        }

        const hours = Number(this.dateService.formatDate(this.serverTime, datetimeFormat.hh));

        if (hours >= 0 && hours < 5) {
          this.greeting = 'Good night';
        } else if (hours >= 5 && Number(hours) < 12) {
          this.greeting = 'Good morning';
        } else if (hours >= 12 && Number(hours) < 17) {
          this.greeting = 'Good afternoon';
        } else if (hours >= 17 && Number(hours) < 19) {
          this.greeting = 'Good evening';
        } else {
          this.greeting = 'Good night';
        }

        this.dataService.sendData(
          this.dataService.typePassData('tech-status-updated', {
            tech: this.tech,
          })
        );
        // });
      },
      (error) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', error);
      }
    );
  }

  /** Toggle edit mode */
  toggleEditMode() {
    if (this.isEditable) {
      this.user = { ...this._user };
      this.errors = {};
      this.previewImage = this._user.image;
    }
    this.isEditable = !this.isEditable;
  }

  /** Logout user, clear cookies and redirect to login */
  handleLogout() {
    this.titleService.setTitle(AutoLeap);
    this.helperService.logout();
  }

  handleFileUpload(event) {
    const [file] = event.target.files;
    if (file) {
      this.openImageCropperDialog(file);
    }
  }

  removeImage() {
    this.user.image = '';
    this.previewImage = '';
    this.isEditable = true;
  }

  handleChange(name: string, value: string) {
    this.user[name] = value;
  }

  openImageCropperDialog(file) {
    const ref = this.dialogService.open(ImageCropperDialogComponent, {
      width: '60%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: { file },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.previewImage = data;
        this.isEditable = true;
        this.isUploading = true;
        const formData = new FormData();
        formData.append('file', this.helperService.dataURLtoBlob(data));
        this.httpService.uploadCompanyLogo(formData).then(
          (url) => {
            this.isUploading = false;
            this.user.image = url.url;
          },
          (err) => {
            this.isUploading = false;
            this.helperService.showToaster('error', err);
          }
        );
      }
      onClose.unsubscribe();
    });
  }

  handleFocus(name: string) {
    this.errors[name] = '';
    this.focus[name] = true;
  }

  handleBlur(name: string) {
    this.focus[name] = false;
  }

  validate() {
    let isValid = true;

    if (!this.user.firstName) {
      this.errors.firstName = 'First name required';
      isValid = false;
    }

    if (!this.user.lastName) {
      this.errors.lastName = 'Last name required';
      isValid = false;
    }

    if (!this.user.email) {
      this.errors.email = 'Email required';
      isValid = false;
    }

    if (!this.user.phone) {
      this.errors.phone = 'Phone required';
      isValid = false;
    }

    // trimming email
    this.user.email = this.user.email.trim();
    if (this.user.email && this.validationService.validatingEmail(this.user.email)) {
      this.errors.email = 'Invalid Email';
      isValid = false;
    }

    return isValid;
  }

  handleAudibleNotificationSettings(notificationSetting) {
    this.userHasAudibleNotification = !notificationSetting;
    this.setUserProfile();
  }

  setUserProfile() {
    const user = {
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      email: this.user.email,
      phone: this.helperService.removePhoneFormatting(this.user.phone),
      image: this.user.image,
      role: this._user.role,
      userId: this.user.userId,
      hasAudibleNotifications: this.userHasAudibleNotification,
    };

    if (!['super', 'onboarder', 'engg', 'sales'].includes(this.user.role)) {
      this.httpService.updateUserProfile(this.user._id, user).then(
        (res) => {
          this.getUser.emit();
          this.helperService.showToaster('success', 'Successfully updated');
          this.toggleEditMode();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  handleSubmit() {
    if (this.validate()) {
      this.setUserProfile();
    }
  }

  handleClockStatusUpdate = (clockedIn: boolean, showResumeOption: boolean, callback?: any) => {
    if (!this.tech.clockedIn) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '35%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: 'Are you sure you want to clock in',
          message: 'You are still on the admin side of the app. Do you want to clock-in as a technician?',
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.updateClockStatus();
        }

        onClose.unsubscribe();
      });
    } else {
      this.updateClockStatus();
    }
  };

  openClockOutDialog = (title) => {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '35%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: 'Pause the In Progress Service',
          message: `Service ${title} is currently In Progress. Clocking out will pause the service. `,
          button: {
            success: { title: 'Clock out' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.updateClockStatus(true);
        }

        onClose.unsubscribe();
      });
  }

  updateClockStatus(forceUpdate: boolean = false) {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    this.httpService.updateClockStatus({ isClockIn: !this.tech.clockedIn, forceUpdate }).then(
      (res: any) => {
        if (res.isAlreadyUpdated) {
          this.helperService.showToaster('error', res.message);
        }
        if(res.isInProgress) {
          this.openClockOutDialog(res?.service?.title)
        } else {
          if (this.tech.clockedIn) {
            this.helperService.showToaster('success', 'Successfully clock out');
          } else {
            this.helperService.showToaster('success', 'Successfully clock in');
          }
        }

        this.isProcessing = false;
        this.getEmployeeData();
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  // handleTechStatusUpdate(service: any, employee: any) {
  //   if (service) {
  //     this.timeOut = setTimeout(() => {
  //       this.dynamicDialogRef.close({
  //         isSuccess: true,
  //         data: employee,
  //       });

  //       if (
  //         service.orderId &&
  //         service.orderId.services &&
  //         this.showResumeOption
  //       ) {
  //         const services = service.orderId.services || [];
  //         for (let i = 0; i < services.length; i++) {
  //           if (
  //             services[i]._id === service.workId &&
  //             services[i].status === 'pause'
  //           ) {
  //             this.openResumeServiceDialog(
  //               service.orderId._id,
  //               service.workId,
  //               services[i].title,
  //               (service.orderId.vehicle && service.orderId.vehicle.name) || ''
  //             );
  //           }
  //         }
  //       }
  //     }, 1000);
  //   } else {
  //     this.timeOut = setTimeout(() => {
  //       this.dynamicDialogRef.close({
  //         isSuccess: true,
  //         data: employee,
  //       });
  //     }, 1000);
  //   }
  // }

  navigateToTech() {
    this.helperService.openPageInSameTab(`/tech/clock`, 'set');
  }

  openCommissionEarnedModal() {
    const ref = this.dialogService.open(CommissionEarnedDialogComponent, {
      width: '800px',
      styleClass: `add-dialog commission-earned-dialog`,
      showHeader: false,
      data: { },
    });

    const onClose = ref.onClose.subscribe(() => {
      onClose.unsubscribe();
    });

    this.toggleProfileCard();
  }

  toggleProfileCard() {
    this.toggleCard.emit();
  }
  
}
